var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfricon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 115.1 103.9",
    style: {
      enableBackground: "new 0 0 115.1 103.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.3,99C28.6,99,14.9,99,1,99C0.9,95.3,0.7,91.6,0.8,88c0.3-7.5,2-14.7,5.8-21.2C13,56,22.5,49.6,34.7,47.5 c11.9-2.1,23,0.3,33,7.5c1,0.7,2,1.6,3.3,2.6c-0.7,0.6-1.4,1-2,1.6c-4.4,4.5-5,10.5-1.7,15.3c2.2,3.1,5.2,4.7,9.1,5 c-0.3,0.4-0.5,0.7-0.8,1c-3,3.1-6.8,4.4-11,4.5C61,85,57.4,85,53.7,85c-7.1,0.1-12.3,6-11.5,13.1C42.2,98.4,42.3,98.7,42.3,99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4,42.9c-12.1,0-21.2-9.2-21.2-21.4c0-11.4,9.8-20.8,21.4-20.8c11.4,0,20.9,9.6,20.9,21.1 C63.5,33.8,54.4,42.9,42.4,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3,68.4c-1.6,1.5-2.9,2.8-4.2,4.1c-2.2,2.1-5.1,2.5-7.4,1.2c-3.1-1.9-3.7-5.9-1.3-8.8c0.7-0.8,1.5-1.6,2.2-2.3 c3.7-3.8,7.5-7.5,11.2-11.2c0.4-0.4,0.7-0.7,1.1-1c2.7-2.4,5.8-2.4,8.4,0.1c1.5,1.4,2.9,2.8,4.4,4.3c3.2,3.2,6.5,6.5,9.7,9.7 c2.9,3,2.4,7.4-1,9.3c-2.3,1.3-5.1,0.9-7.2-1.2c-1.1-1.1-2.1-2.2-3.2-3.3c-0.2-0.2-0.5-0.4-0.7-0.7c-0.1,0-0.3,0-0.4,0.1 c0,0.9,0,1.8,0,2.6c0,6.3-1.6,12.2-5,17.6c-5.3,8.2-12.9,12.9-22.5,13.9c-5.4,0.6-10.9,0.4-16.4,0.4c-2.9,0-5.1-2.6-5.1-5.6 c0-3,2.2-5.6,5.2-5.7c3.7-0.1,7.4,0,11.1-0.1c4.2-0.1,8.2-0.9,11.7-3.2c5.4-3.4,8.2-8.3,9.1-14.5C88.2,72.3,88.2,70.5,88.3,68.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfricon2);
export default __webpack_public_path__ + "static/media/transfr icon2.57328e2b8e62036b2cf106e22feac50f.svg";
export { ForwardRef as ReactComponent };